import { useContext, useEffect } from "react";
import { TransferContext } from "../../context/TransferContext";
import { STEP_SCHEDULE_PHONE_CALL_LOADING, STEP_SPOUSE_NOTARY, STEP_TRANSFER_TASKS } from "../../class/transferDetails";
import { BRIDGE_DEVELOPMENT } from "../../typings";
import { AppContext } from "../../context/AppContext";
import { MockTask, TransferTask } from "../../class/transferTask";

const useTransferTasks = () => {
  const { appEnv } = useContext(AppContext);
  const isMock = appEnv === BRIDGE_DEVELOPMENT;
  const { currentScreen, goToScreen, transferTasks } = useContext(TransferContext);
  const spouseNotary = transferTasks.filter((task: MockTask | TransferTask) => task.type === "SPOUSAL_CONSENT")[0];

  const onClickGotIt = () => {
    goToScreen(STEP_SCHEDULE_PHONE_CALL_LOADING);
  };

  const goToNextTask = () => {
    if (!isMock) {
      // check tasks
      if (spouseNotary && !(spouseNotary as TransferTask).completedOn && currentScreen === STEP_TRANSFER_TASKS) {
        goToScreen(STEP_SPOUSE_NOTARY);
        return;
      }
    } else {
      if (spouseNotary) {
        goToScreen(STEP_SPOUSE_NOTARY);
        return;
      }
    }
    // Schedule phone call
    goToScreen(STEP_SCHEDULE_PHONE_CALL_LOADING);
  };

  useEffect(() => {
    if (currentScreen === STEP_TRANSFER_TASKS) {
      goToNextTask();
    }
  }, [currentScreen]);

  return {
    isMock,
    currentScreen,
    goToNextTask,
    onClickGotIt,
  };
};

export default useTransferTasks;
